import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {

  transform(value: number, maximumFractionDigits: number = 1): string {
    if (value >= 1000000000000000) {
      return (value / 1000000000000000).toFixed(maximumFractionDigits).replace(/\.0$/, '') + 'Q';
    } else if (value >= 1000000000000) {
      return (value / 1000000000000).toFixed(maximumFractionDigits).replace(/\.0$/, '') + 'T';
    } else if (value >= 1000000000) {
      return (value / 1000000000).toFixed(maximumFractionDigits).replace(/\.0$/, '') + 'B';
    } else if (value >= 1000000) {
      return (value / 1000000).toFixed(maximumFractionDigits).replace(/\.0$/, '') + 'M';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(maximumFractionDigits).replace(/\.0$/, '') + 'K';
    } else {
      return value.toString();
    }
  }

}
